export const ADMIN_USER_CORPORATE_PATH = '/admin/user-corporate'

export interface IUserCorporateMembership {
  corporateId: string
  corporateName: string
  corporateActive: boolean
  defaultCorporate: boolean
}

/** UserCorporatesResponse */
export interface IUserCorporatesModel {
  id?: string
  userId: string
  username: string
  email: string
  firstName?: string | null
  lastName?: string | null
  active: boolean
  corporates: IUserCorporateMembership[]
}
